export const CONTACT_EMAIL = 'olivier.lott@yourprivatetrip.com';
